import axios from 'axios';
import {backendHost} from '../../config';

export const postOffers = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/offer`, params);
};